import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch products from JSON file
    fetch("/products.json")
      .then((response) => response.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading products:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative h-[50vh] bg-gradient-to-br from-primary/85 to-black/70 bg-cover bg-center"
        style={{ backgroundImage: "url(/img/background.webp)" }}
      >
        <div className="absolute inset-0 flex items-center justify-center text-center text-white">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold uppercase mb-4 drop-shadow-lg">
              Our Products
            </h1>
            <p className="text-xl md:text-2xl font-light max-w-2xl mx-auto drop-shadow">
              Handcrafted excellence for your home and office
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 px-4 bg-white text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Discover Quality Craftsmanship
          </h2>
          <p className="text-gray-600 text-lg">
            Each piece is carefully crafted with precision and attention to
            detail. Browse our collection of custom woodwork solutions designed
            to transform your space and elevate your style.
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="h-64 bg-gradient-to-br from-gray-100 to-gray-200 p-4">
                <img
                  src={
                    product.images?.[0] ||
                    product.image ||
                    "/img/placeholder.jpg"
                  }
                  alt={product.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2 group-hover:text-primary transition-colors">
                  {product.name}
                </h3>
                <div className="text-2xl font-bold text-primary">
                  N${product.price}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <section className="bg-gradient-primary text-white py-16 text-center">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Need Something Custom, Urgent?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            We specialize in specialized woodworking tailored to your specific
            needs
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-primary px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 hover:scale-105 transition-all duration-300"
          >
            Get In Touch
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Products;
